import React from 'react';

export const ViewBody = ({ children }) => (
  <div className="px-3 py-3">{children}</div>
);
